import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RedeemBrand from "../../components/User/RedeemBrand";

export default withRouter(connect()(RedeemBrand));
